import { Injectable } from '@angular/core';
import { PessoaEndereco, PessoaFisica } from '@tivic-team/manager-ts/dist/grl';
import { Concessao } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity';
import { ConcessionarioPessoa } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessionario-pessoa.entity';
import { DocumentoArquivoDTO } from '../ptc/documento-arquivo.dto';

@Injectable()
export class ConcessionarioPessoaDTO extends ConcessionarioPessoa{

    cdEmpresa: number;
    cdVinculo: number;
    concessao: Concessao;
    pessoaFisica: PessoaFisica = void(0);
    pessoaEndereco: PessoaEndereco = void(0);
    documentoArquivoDTO: Array<DocumentoArquivoDTO> = void(0);
    cdUsuarioCadastro: number = void(0);
    cdUsuarioDesvinculacao: number = void(0);
    constructor(
        cdEmpresa?: number,
        cdVinculo?: number,
        concessao?: Concessao,
        pessoaFisica?: PessoaFisica,
        pessoaEndereco?: PessoaEndereco,
        documentoArquivoDTO?: Array<DocumentoArquivoDTO>,
        cdUsuarioCadastro?: number,
        cdUsuarioDesvinculacao?: number,
    ) {
        super();
        this.cdEmpresa = cdEmpresa;
        this.cdVinculo = cdVinculo;
        this.concessao = concessao;
        this.pessoaFisica = pessoaFisica;
        this.pessoaEndereco = pessoaEndereco;
        this.documentoArquivoDTO = documentoArquivoDTO;
        this.cdUsuarioCadastro = cdUsuarioCadastro;
        this.cdUsuarioDesvinculacao = cdUsuarioDesvinculacao;
    }
}

export class ConcessionarioPessoaDTOList {
    items: Array<ConcessionarioPessoaDTO>;
    total: number;

    constructor() {}
}